import Debug from 'debug'
import store from 'store'
import getDeviceId from 'utils/getDeviceId'
const debug = Debug('app:track')
const deviceId = getDeviceId()
const connection =
  navigator.connection || navigator.mozConnection || navigator.webkitConnection

function setFirebaseUserProperties(analytics, properties) {
  analytics.setUserProperties(
    {
      device_id: deviceId,
      screen_height: window.screen.height,
      screen_width: window.screen.width,
      wifi:
        connection && (connection.type || connection.effectiveType) === 'wifi',
      app_version: process.env.__version__,
      funded_user: Number(store.getters.isDeposited),
      distinct_id:
        store.state.account.identity && store.state.account.identity.uuid,
      ...properties
    },
    {
      global: true
    }
  )
}

export default {
  install(Vue) {
    const firebase = window.firebase
    let trackFunc = function() {
      debug('none track')
    }
    if (firebase && ['production', 'preview'].includes(process.env.BUILD_ENV)) {
      firebase.initializeApp({
        apiKey: 'AIzaSyBUQzWWwKLdI-nwM_YAXtQj-tZme8RRowM',
        authDomain: 'tradeup-web.firebaseapp.com',
        databaseURL: 'https://tradeup-web.firebaseio.com',
        projectId: 'tradeup-web',
        storageBucket: 'tradeup-web.appspot.com',
        messagingSenderId: '1020964966755',
        appId: '1:1020964966755:web:5928838733c186686bc356',
        measurementId: 'G-70YNWD7GY2'
      })
      const analytics = firebase.analytics()
      setFirebaseUserProperties(analytics)
      // uuid 改变修改参数
      store.watch(
        state => {
          return state.account.identity && state.account.identity.uuid
        },
        uuid => {
          setFirebaseUserProperties(analytics, { distinct_id: uuid })
        }
      )
      // 入金状态改变，修改参数
      store.watch(
        (state, getters) => {
          return getters.isDeposited
        },
        deposited => {
          setFirebaseUserProperties(analytics, {
            funded_user: Number(deposited)
          })
        }
      )
      window.addEventListener('resize', () => {
        setFirebaseUserProperties(analytics, {
          screen_height: window.screen.height,
          screen_width: window.screen.width
        })
      })
      trackFunc = analytics.logEvent
    }
    Vue.track = trackFunc
    Vue.prototype.$track = trackFunc
    Vue.directive('track', {
      bind(el, binding) {
        const { arg, value, expression, modifiers } = binding
        el.__trackEvent__ = value || expression || arg
        if (modifiers.click) {
          el.addEventListener('click', () => {
            debug('track event:', el.__trackEvent__)
            trackFunc(el.__trackEvent__, el.__trackParams__)
          })
        }
        if (Object.keys(modifiers).length === 0) {
          debug('track event:', el.__trackEvent__)
          trackFunc(el.__trackEvent__, el.__trackParams__)
        }
      },
      update(el, { arg, value, expression }) {
        el.__trackEvent__ = value || expression || arg
      }
    })
    Vue.directive('track-params', {
      bind(el, { value }) {
        el.__trackParams__ = value
      },
      update(el, { value }) {
        el.__trackParams__ = value
      }
    })
  }
}
